import { render, staticRenderFns } from "./SpecifyExpiryDate.vue?vue&type=template&id=008174a4&scoped=true"
import script from "./SpecifyExpiryDate.vue?vue&type=script&lang=js"
export * from "./SpecifyExpiryDate.vue?vue&type=script&lang=js"
import style0 from "./SpecifyExpiryDate.vue?vue&type=style&index=0&id=008174a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008174a4",
  null
  
)

export default component.exports